import { render, staticRenderFns } from "./PromotionListExpired.vue?vue&type=template&id=6811995b"
import script from "./PromotionListExpired.vue?vue&type=script&lang=js"
export * from "./PromotionListExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports